import { Typography } from "@mui/material";
import { useState } from "react";
import HelpDialogLayout, {
  ContentStack,
  HelpDialogButton,
  HelpDialogLayoutProps,
  HelpDialogLink,
  SectionStack,
} from "./HelpDialogLayout";

export interface DiseaseDescriptionDialogProps
  extends Omit<HelpDialogLayoutProps, "children" | "title"> {}

export function DiseaseDescriptionDialog(props: DiseaseDescriptionDialogProps) {
  return (
    <HelpDialogLayout title="睡眠時無呼吸症候群／不眠症とは" {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2">睡眠時無呼吸症候群</Typography>
          <Typography variant="body2">
            睡眠時無呼吸症候群は、眠っている間に呼吸が止まってしまう病気です。呼吸をするために夜間何度も覚醒してしまい、十分な睡眠がとれなくなります。
          </Typography>
          <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
            参考：
            <HelpDialogLink href="https://kennet.mhlw.go.jp/information/information/dictionary/heart/yk-026">
              厚生労働省 健康づくりサポートネット（睡眠時無呼吸症候群 / SAS）
            </HelpDialogLink>
          </Typography>
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">不眠症</Typography>
          <Typography variant="body2">
            不眠症は、眠りたいのに寝付きが悪い・何度も目が覚める・眠りが浅いなどの睡眠問題が慢性化して、結果として日中に不調が発生してしまう病気です。
          </Typography>
          <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
            参考：
            <HelpDialogLink href="https://kennet.mhlw.go.jp/information/information/dictionary/heart/yk-083">
              厚生労働省 健康づくりサポートネット（不眠症）
            </HelpDialogLink>
          </Typography>
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}

export default function DiseaseDescriptionDialogButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <HelpDialogButton onClick={() => setOpen(true)}>
        各疾患の解説
      </HelpDialogButton>
      <DiseaseDescriptionDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
